import * as React from 'react';
import Box from '@mui/material/Box';
import { Slider as MuiSlider, styled } from '@mui/material';

const ProfessionalSlider = styled(MuiSlider)({
  color: '#4f46e5', // indigo-600 to match the main app theme
  height: 6,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#ffffff',
    border: '2px solid currentColor',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(79, 70, 229, 0.16)',
    },
    '&.Mui-focusVisible': {
      boxShadow: '0 0 0 8px rgba(79, 70, 229, 0.16)',
    },
    '&.Mui-active': {
      boxShadow: '0 0 0 12px rgba(79, 70, 229, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    height: 6,
    borderRadius: 3,
  },
  '& .MuiSlider-rail': {
    color: '#e5e7eb', // gray-200
    opacity: 1,
    height: 6,
    borderRadius: 3,
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#9ca3af',
    height: 4,
    width: 4,
    borderRadius: '50%',
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: '#ffffff',
    },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: '600',
    top: -2,
    backgroundColor: '#374151', // gray-700
    borderRadius: 4,
    padding: '2px 8px',
  },
});

export default function RatingRangeSlider(props) {
  // Use initialValue if provided, otherwise default to [1, 5] for ratings
  const [value, setValue] = React.useState(props.initialValue || [1, 5]);

  React.useEffect(() => {
    if (props.initialValue) {
      setValue(props.initialValue);
    }
  }, [props.initialValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (props.handlerRatingChange) {
      props.handlerRatingChange(newValue);
    }
  };

  return (
    <Box sx={{ width: { xs: '100%', sm: 220, md: 250 } }} className="flex flex-col px-2">
      <label className="mb-1 text-sm font-medium text-gray-700">Rating Range</label>
      <ProfessionalSlider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaLabel={() => 'Rating range'}
        valueLabelFormat={(val) => val}
        min={1}
        max={5}
        step={1}
        marks={true}
        disableSwap
      />
    </Box>
  );
}
